import { useEffect } from 'react'
import { useLocation } from 'react-router'
import { trackEvent } from '@/lib/analytics'

export function AnalyticsTracker() {
  const location = useLocation()

  useEffect(() => {
    trackEvent('page_view', { path: location.pathname + location.search })
  }, [location])

  return null
}
